<template>
  <div class="contact">
    <div style="background: #E9F3FF;  padding-top: 60px;padding-bottom: 40px">
      <section class="solution en">
        <h2>Contact Us</h2>
        <div class="common-card">
          <div class="img-contain" style="width: 600px;height: 470px;">
            <img class="img3 strong-img" src="@/assets/contact-2.jpg" style="width: 100%;
  height: 100%;
  object-fit: cover;" >
          </div>
          <div class="p2" style="margin-bottom: 0">
<!--            <div class="contain-card">-->
<!--              <p class="title">Phone</p>-->
<!--              <p class="info">33333 hewo</p>-->
<!--              <div class="card-icon">-->
<!--                <img src="@/assets/contact/phone.png" alt="">-->
<!--              </div>-->
<!--            </div>-->
            <div class="contain-card">
              <p class="title">E-mail</p>
              <p class="info">sales@hewvo.com</p>
              <img src="@/assets/contact/mail.png" alt="">
            </div>
            <div class="contain-card">
              <p class="title">Website</p>
              <p class="info">www.hewvo.com</p>
              <img src="@/assets/contact/network.png" alt="">
            </div>
            <div class="contain-card">
                <p class="title">Address</p>
                <p class="info">7500A BEACH ROAD #05-319 THE PLAZA SINGAPORE(199591)</p>
              <img src="@/assets/contact/address.png" alt="">
            </div>

          </div>
        </div>
      </section>
    </div>

    <!--  <div style="height: 50px"></div>-->
  </div>
</template>

<script>
import Products from "@/views/products.vue";

export default {
  name: "solution",
  components: {Products},
  data() {
    return {
      activeIndex: 0,
      img: require('@/assets/solution2/导图1.jpeg'),
      img_en: require('@/assets/solution2/all1.jpeg'),
      img2_en: require('@/assets/solution2/all2.png'),
      contentClass: 'content',
    }
  },
  computed: {
    is_en() {
      return this.$t('language') === 'English'
    },
    list() {
      return [
        {
          title: this.$t('solution1.computer_industry.title'),
          title2: this.$t('solution1.computer_industry.title2'),
          desc1: this.$t('solution1.computer_industry.desc1'),
          desc2: this.$t('solution1.computer_industry.desc2'),
          img: require('@/assets/solution1/computer.png')
        },
        {
          title: this.$t('solution1.phone_industry.title'),
          title2: this.$t('solution1.phone_industry.title2'),
          desc1: this.$t('solution1.phone_industry.desc1'),
          desc2: this.$t('solution1.phone_industry.desc2'),
          img: require('@/assets/solution1/phone1.png')
        },
        {
          title: this.$t('solution1.car_industry.title'),
          title2: this.$t('solution1.car_industry.title2'),
          desc1: this.$t('solution1.car_industry.desc1'),
          desc2: this.$t('solution1.car_industry.desc2'),
          img: require('@/assets/solution1/car.png')
        },
        {
          title: this.$t('solution1.communication_industry.title'),
          title2: this.$t('solution1.communication_industry.title2'),
          desc1: this.$t('solution1.communication_industry.desc1'),
          desc2: this.$t('solution1.communication_industry.desc2'),
          img: require('@/assets/solution1/wifi.png')
        },
        {
          title: this.$t('solution1.home_appliance_industry.title'),
          title2: this.$t('solution1.home_appliance_industry.title2'),
          desc1: this.$t('solution1.home_appliance_industry.desc1'),
          desc2: this.$t('solution1.home_appliance_industry.desc2'),
          img: require('@/assets/solution1/jiadian.png')
        },
        {
          title: this.$t('solution1.digital_product_industry.title'),
          title2: this.$t('solution1.digital_product_industry.title2'),
          desc1: this.$t('solution1.digital_product_industry.desc1'),
          desc2: this.$t('solution1.digital_product_industry.desc2'),
          img: require('@/assets/solution1/camera.png')
        },
        {
          title: this.$t('solution1.medical_equipment_industry.title'),
          title2: this.$t('solution1.medical_equipment_industry.title2'),
          desc1: this.$t('solution1.medical_equipment_industry.desc1'),
          desc2: this.$t('solution1.medical_equipment_industry.desc2'),
          img: require('@/assets/solution1/hospital.png')
        }
      ];
    }
  },
  methods: {
    handleSelect(index, indexPath) {
      this.contentClass = 'content'
      setTimeout(() => {
        this.activeIndex = index
        this.contentClass = 'content slide-element'
      }, 200)
    }
  },
  mounted() {
    this.handleSelect(this.activeIndex)
  }
}
</script>

<style lang="scss" scoped>
section {
  width: 1200px;
  margin: 0 auto;
  padding-top: 5rem;
}
.common-card{
  display: flex;
  margin-bottom: 40px;
  .img-contain{
    margin-right: 60px;
  }
}

.solution {
  margin: 0 auto;
  position: relative;
  line-height: 2;
  min-height: calc(100vh - 60px - 60px);
  h2 {
    //color: var(--primary-color);
    color: #000000;
    margin-bottom: 3rem;
    font-size: 40px;
    font-family: Inter, Tahoma, Verdana, sans-serif;
    text-align: center;
    font-weight: 500;
  }
  .el-card {
    margin-bottom: 30px;
  }
  .group {
    display: flex;
    align-items: center;
  }
  .img {
    width: 800px;
    height: 350px;
    position: relative;
    overflow: hidden;
    margin: 0 auto;
  }
  .img1 {
    position: absolute;
    width: 800px;
    top: -120px;
    left: 50%;
    margin-left: -400px;
    z-index: 1;
  }
  .img4 {
    //position: absolute;
    //width: 600px;
    //top: -30px;
    //left: 50%;
    //margin-left: -300px;
    width: 600px;
    border-radius: 5px;
    z-index: 1;
  }
  .img2 {
    height: 300px;
    background: rgb(246,246,248);
    margin-right: 20px;
    border-radius: 10px;
    overflow: hidden;
  }
  .img3 {
    width: 600px;
    border-radius: 5px;
    overflow: hidden;
  }
  .p1,.p2,.p3 {
    padding-bottom: 30px;
  }
  .p2{
    font-size: 22px;
    line-height: 33px;
    max-width: 900px;
    margin: 0 auto 3rem;
    color: #000;
    font-family: Inter, Tahoma, Verdana, sans-serif;
  }
  .contain-card{
    width: 400px;
    border-radius:10px;
    padding: 20px 80px;
    margin-bottom: 40px;
    background: #fff;
    border: 1px solid  rgb(255, 107, 53);
    position: relative;
    img{
      position: absolute;
      width: 40px;
      height: 40px;
      left: 20px;
      top: 40px;
    }
    //.card-icon{
    //  position: absolute;
    //  width: 60px;
    //  height: 60px;
    //  background: rgb(255, 107, 53);
    //  border-radius: 30px;
    //  left: -30px;
    //  top: 50%;
    //  margin-top: -30px;
    //  text-align: center;
    //
    //}
    .title{
      font-size: 1.5rem;
      margin-bottom: 10px;
    }
    .info{
      font-size: 16px;
    }
  }
}
@media (max-width: 768px) {
  .contact section{
    width: 100%;
  }
  .img-contain {
    display: none;
  }
  .common-card {
    display: block;
  }
  .p2 {
    width: 100%;
  }
  .solution .contain-card {
    width:90%;
    margin: 20px auto;
    box-sizing: border-box;
  }
}
</style>
